/**
 * Reset
 *
 * Resets the in object data back to original values.
 */

const reset = (BIDS) => {
  BIDS.issues = []
}

export default reset
